import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      backgroundColor: '#fff',
      borderRadius: '4px',
      margin: '32px',
      width: '90%',
      maxWidth: (props) => props.modalType === 'activeBatches' ? '1200px' : '900px',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: 'none',
    position: 'relative',
    minHeight: '60px',
  },
  title: {
    fontWeight: 600,
    fontSize: '18px',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    color: '#000',
    margin: 0,
    width: '100%',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    cursor: 'pointer',
    zIndex: 10,
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '&:hover': {
      opacity: 0.7,
    },
  },
  closeText: {
    fontSize: '14px',
    color: '#000',
  },
  closeIcon: {
    color: '#FF0000',
    fontSize: '28px',
  },
  dialogContent: {
    padding: '32px 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: (props) => props.modalType === 'activeBatches' ? 'auto' : '200px',
  },
  tableContainer: {
    width: '100%',
    maxWidth: (props) => props.modalType === 'activeBatches' ? '100%' : '700px',
    marginBottom: '32px',
    border: '1px solid #E0E0E0',
  },
  table: {
    width: '100%',
  },
  headerCell: {
    backgroundColor: '#F9F9FC',
    fontWeight: (props) => props.modalType === 'activeBatches' ? 700 : 500,
    padding: '12px 16px',
    fontSize: '14px',
    borderBottom: '1px solid #E0E0E0',
  },
  tableCell: {
    padding: '12px 16px',
    fontSize: '14px',
    verticalAlign: 'top',
  },
  multiLineCell: {
    lineHeight: '1.5',
  },
  documentName: {
    color: '#2196F3',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  okButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '6px 40px',
    minWidth: '120px',
    height: '36px',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
  },
  uploadButton: {
    border: '1px solid #000',
    color: '#000',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '6px 12px',
    marginTop: '4px',
    height: '32px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
      border: '1px solid #000',
    },
  },
  digitalizedMbrButton: {
    background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
    color: '#ffffff',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '6px 20px',
    marginTop: '4px',
    marginLeft: '12px',
    height: '32px',
    minHeight: '32px',
    fontSize: '14px',
    fontWeight: 500,
    border: 'none',
    boxSizing: 'border-box',
    '&:hover': {
      background: 'linear-gradient(82deg, #3B173F 0%, #073270 100%) 0% 0% no-repeat padding-box',
      opacity: 0.9,
    },
  },
}));

